var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classnames},[_c('div',{ref:"inputs",staticClass:"ui-input-box"},[_c('CodeInput',{key:_vm.refresh_cnt,attrs:{"loading":false,"auto-focus":true,"field-height":44,"field-width":44},on:{"change":_vm.onChange,"complete":_vm.onComplete}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }